import React from 'react';
export function SiteFooter() {
  return <footer className="w-full bg-pitch" data-id="element-180" data-mp="3rjvz5hlqcyja">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" data-id="element-181" data-mp="1bettc3zu76jg">
        <p className="text-lg font-extrabold text-white" data-id="element-182" data-mp="1bh6kn7rhit96">Método Fútbol Digital</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-body" data-id="element-183" data-mp="1fh6wqlr42sd2">
          El método para que papás y mamás en Colombia acompañen, protejan y planifiquen la carrera
          futbolística de sus hijos e hijas en las divisiones menores.
        </p>
        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-body" data-id="element-184" data-mp="rqba031iinco">
          <li data-id="element-185" data-mp="wpxpyk8q6hp6">
            <a href="mailto:solucionesoinformacion@gmail.com" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-186" data-mp="wpe6gz3ffl91">
              📧 solucionesoinformacion@gmail.com
            </a>
          </li>
          <li data-id="element-187" data-mp="90bpzukj3yg4">
            <a href="https://instagram.com/metodofutboldigital" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-188" data-mp="8ztl69jswbwl">
              📱 @metodofutboldigital
            </a>
          </li>
          <li data-id="element-189" data-mp="6nmog5ilp6lj">
            <a href="https://metodofutboldigital.shop" className="transition-colors duration-150 ease-out hover:text-brand-green" data-id="element-190" data-mp="1utk3ir1o09z">
              🌐 metodofutboldigital.shop
            </a>
          </li>
        </ul>
        <p className="mt-8 text-xs text-subtle" data-id="element-191" data-mp="3o2t4ak7cdq9l">
          Acceso digital inmediato · Material en PDF · Soporte por correo
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-subtle" data-id="element-192" data-mp="3j59rzpu7fnka">
          Este material es educativo y no reemplaza la asesoría de un abogado especializado en
          derecho deportivo. Los procedimientos y reglamentos en Colombia se actualizan: verifique
          siempre con el club y con la FCF, y consulte con un profesional especializado antes de
          firmar.
        </p>
        <p className="mt-3 text-xs text-subtle" data-id="element-193" data-mp="18914ma6614s3">
          © 2026 Método para padres de futbolistas™ — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}